import { gsap } from 'gsap';

// ALl of this JS should probably live in the root of the theme
// because GSAP is shared by other parts of the site

// Nav
// Burger
// Sub menu
jQuery(document).ready(function () {
	// Function to open the menu with GSAP animation
	function openMenu() {
		// Show the menu using GSAP animation
		gsap.to('.wawHeaderMobile--subMenu', { y: 0, duration: 0.5, ease: 'power2.out' });
	}

	// Function to close the menu with GSAP animation
	function closeMenu() {
		// Hide the menu using GSAP animation
		gsap.to('.wawHeaderMobile--subMenu', { y: -1000, duration: 0.5, ease: 'power2.out' });
	}

	function showFilters() {
		// Show the menu using GSAP animation
		gsap.to('.wawListingsQuery__filters', { y: 0, duration: 0.5, ease: 'power2.out' });
	}

	function closeFilters() {
		// Show the menu using GSAP animation
		gsap.to('.wawListingsQuery__filters', {
			y: -1000,
			duration: 0.5,
			ease: 'power2.out',
			onComplete: function () {
				gsap.set(this.targets(), { clearProps: 'all' });
			},
		});
	}

	// Toggle menu state on button click
	jQuery('.wawBurgerMenu--open').on('click', function () {
		openMenu(); // Open the menu if it's closed
	});

	// Burger Close
	jQuery('.wawBurgerMenu--close').on('click', function () {
		closeMenu(); // Open the menu if it's closed
	});

	// Filters
	jQuery('.wawDirectory__showFilters').on('click', function () {
		showFilters(); // Open the menu if it's closed
	});

	jQuery('.wawListingsQuery__button-search').on('click', function () {
		closeFilters(); // Open the menu if it's closed
	});
	jQuery('.wawDirectory__closeFilters').on('click', function () {
		closeFilters(); // Open the menu if it's closed
	});
});

// Search
// Search Options
jQuery(document).ready(function () {
	// Function to open the menu with GSAP animation
	function openMenu() {
		// Show the menu using GSAP animation
		gsap.to('.wawHeaderMobile__search--form', { y: 10, duration: 0.5, ease: 'power2.out' });
	}

	// Function to close the menu with GSAP animation
	function closeMenu() {
		// Hide the menu using GSAP animation
		gsap.to('.wawHeaderMobile__search--form', { y: -1000, duration: 0.5, ease: 'power2.out' });
	}

	// Toggle menu state on button click
	jQuery('.wawHeaderMobile__search--open').on('click', function () {
		openMenu(); // Open the menu if it's closed
	});

	jQuery('.wawHeaderMobile__search--close').on('click', function () {
		closeMenu(); // Open the menu if it's closed
	});

	// Add event listener for Enter key on the search field
	jQuery('.searchField').on('keydown', (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			jQuery(event.target).closest('form').submit();
		}
	});

	jQuery('.wawSearchFiltered__buttons-clear').on('click', function () {
		// Select all input fields within the container
		const inputFields = jQuery('.wawHeaderMobile__search .wawSearchFiltered__inputs input');
		const selectElements = jQuery('.wawHeaderMobile__search .wawSearchFiltered__inputs select');
		const niceSelect = jQuery('.wawHeaderMobile__search .wawSearchFiltered__inputs .nice-select');

		// Reset the values of all input fields
		inputFields.val('');

		// Reset the selected options in regular select elements
		selectElements.each(function () {
			this.selectedIndex = 0; // Reset selected index
		});
		niceSelect.find('.current').text(''); // Reset the displayed text
		niceSelect.find('input[type="hidden"]').val(''); // Reset the hidden input value
		niceSelect.find('.list li').removeClass('selected focus');
		niceSelect.niceSelect('update');
	});
});
